import {useState} from 'react'
import { Link, useNavigate} from "react-router-dom";
import { supabase } from './SupabaseClient'
import { useRecoilState } from 'recoil'
import { authSessionState } from '../atoms/auth'
import {v4 as uuidv4} from 'uuid';

export default function AddGcode() {
    const navigate = useNavigate();
    const [session, set_session] = useRecoilState(authSessionState)

    const [gcode_data_name, set_gcode_data_name] = useState("")
    const [gcode_data_description, set_gcode_data_description] = useState("")
    const [gcode_file, set_gcode_file] = useState<any>(null)

    const handleGcodeFile = (e:any) => {
        set_gcode_file(e.target.files[0])
    }

    const handleNewGcodeData = async () => {
        console.log("Add New Gcode Data")

        console.log(gcode_data_name)
        console.log(gcode_data_description)
        console.log(gcode_file)
        console.log(session)

        //add table
        const {data, error}:any = await supabase
            .from('print_data')
            .insert({user_id:session.user.id, name:gcode_data_name,  note:gcode_data_description})
            .select()
        if (error){
            console.log(error)
            alert(error)
            return;
        }

        console.log(data)


        //Send DB data
        //const file_name = uuidv4()
        //console.log(file_name)
        const save_path =`${session.user.id}/${data[0].id}.gcode`
        console.log("save path: " + save_path)

        //Send Gcode
        const { data:s_data, error: s_error } = await supabase
          .storage
          .from('print_data')
          .upload(save_path, gcode_file)

        //uploaded
        console.log(s_data)
        console.log(s_error)




        navigate("/")

    }
    
    return (
        <>
            <div className="bg-white py-6 sm:py-8 lg:py-12 w-full">
                <div className="px-4 md:px-8 mx-auto">
                    <div className="flex justify-between items-end gap-4 mb-6">
                        <h2 className="text-gray-800 text-2xl lg:text-3xl font-bold">Add Gcode Data</h2>
                    </div>

                    <div className="flex flex-col">
                        <div className="w-full mb-5">
                          <label  className="text-gray-800 text-sm sm:text-base mb-2">
                            Gcode Data name
                            <input 
                                type="text"
                                value={gcode_data_name}
                                onChange={(e)=>{set_gcode_data_name(e.target.value)}}
                                className="w-full bg-gray-50 text-gray-800 border focus:ring ring-indigo-300 rounded outline-none transition duration-100 px-3 py-2" />
                            </label>
                        </div>

                        <div className="w-full mb-5">
                          <label  className="text-gray-800 text-sm sm:text-base mb-2">
                            Gcode Data 説明
                            <textarea 
                                rows={5}
                                value={gcode_data_description}
                                onChange={(e)=>{set_gcode_data_description(e.target.value)}}
                                className="w-full bg-gray-50 text-gray-800 border focus:ring ring-indigo-300 rounded outline-none transition duration-100 px-3 py-2" />
                            </label>
                        </div>
                        <div className="w-full mb-5">
                            <label  className="text-gray-800 text-sm sm:text-base mb-2">
                                Gcode ファイルの設定
                              <input 
                                onChange={handleGcodeFile} 
                                type="file" 
                                className="block w-full text-sm text-slate-500
                                file:mr-4 file:py-2 file:px-4
                                file:rounded-full file:border-0
                                file:text-sm file:font-semibold
                                file:bg-violet-50 file:text-violet-700
                                hover:file:bg-violet-100
                              "/>
                            </label>
                        </div>

                        <div className="w-full mt-5 mb-5">
                            <div className="flex flex-row-reverse">
                                <button onClick={handleNewGcodeData} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded">
                                    Gcode Dataの新規追加
                                </button>
                                <Link to="/" className="mr-5 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow">
                                    Canccel
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}